import React, { Component } from 'react';

class RadioButtonFiltros extends Component {

    render() {
        const { index, rdSeleccionado, selectRadio, PropiedadId } = this.props

        return (
            <div className="VistaInstanciaParametro-Filtros-Contenedor-Check-Flex">
                <div className="col-xs-12">
                    <div className="container-radio-atlas radio-margin">
                        <input
                            id={"rbValorExacto." + PropiedadId}
                            type="radio"
                            name={"rbValorExacto." + PropiedadId}
                            value='E'
                            checked={rdSeleccionado == "E"}
                            onClick={(e) => { 
                                selectRadio("E", index, e.target.id.split(".")[1])
                             }}
                        />
                        <label
                            className="VistaInstanciaParametro-Filtros-Label-Radio label-radioButton"
                            htmlFor={"rbValorExacto." + PropiedadId}>
                            {"Valor exacto"}
                        </label>
                    </div>
                </div>

                <div className="col-xs-12">
                    <div className="container-radio-atlas">
                        <input
                            id={"rbValorParcial." + PropiedadId}
                            type="radio"
                            name={"rbValorParcial." + PropiedadId}
                            value='P'
                            checked={rdSeleccionado == "P"}
                            onClick={(e) => { 
                                selectRadio("P", index, e.target.id.split(".")[1])
                             }}
                        />
                        <label
                            className="VistaInstanciaParametro-Filtros-Label-Radio label-radioButton"
                            htmlFor={"rbValorParcial." + PropiedadId}>
                            {"Valor parcial"}
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default RadioButtonFiltros;